module.exports = __webpack_public_path__ + "static/media/defaultAvatar.fd0c5598.png";